/**
 * Helpers purs pour le code de liaison parent ⇄ enfant (migration 0150).
 * Le code est partagé via lien ou QR ; n'importe laquelle des deux parties
 * (parent ou élève) peut générer le sien et activer celui de l'autre.
 */

/** Longueur du code de liaison (8 caractères, alphabet sans 0/O/1/I/L). */
export const PARENT_LINK_CODE_LENGTH = 8;

const NON_ALNUM = /[^A-Z0-9]/g;

/**
 * Nettoie une saisie utilisateur en un code canonique : majuscules, on retire
 * tout ce qui n'est pas alphanumérique, et on tronque à la longueur attendue.
 */
export function normalizeParentLinkCode(raw: string): string {
  return raw.toUpperCase().replace(NON_ALNUM, '').slice(0, PARENT_LINK_CODE_LENGTH);
}

/** Vrai si la saisie nettoyée forme un code complet. */
export function isValidParentLinkCode(raw: string): boolean {
  return normalizeParentLinkCode(raw).length === PARENT_LINK_CODE_LENGTH;
}

/**
 * Construit l'URL partageable (lien / QR) qui ouvre l'écran d'acceptation
 * `/lier-parent/$code`. `origin` provient de `window.location.origin`.
 */
export function buildParentLinkShareUrl(origin: string, code: string): string {
  return `${origin}/lier-parent/${code}`;
}
